// @flow
import ScreenshotsSection from './ScreenshotsSection';

export default ScreenshotsSection;
